import React from "react";
import { MapPin, Clock, Moon } from "lucide-react";
import { Reveal } from "@/components/effects/Reveal";
import { T } from "@/context/SiteContent";

export const Delivery = ({ resorts }) => (
  <section id="delivery" className="section relative">
    <div className="section-tint" />
    <div className="container">
      <div className="grid md:grid-cols-2 gap-14 items-start">
        <Reveal>
          <p className="eyebrow mb-4"><T k="delivery.eyebrow" fallback="Delivery · Every corner of the Kingdom" /></p>
          <h2 className="font-serif text-5xl md:text-6xl tracking-tight leading-none">
            <T k="delivery.headline" fallback="We meet you where the magic happens." />
          </h2>
          <p className="mt-6 text-[#B9C8D5] leading-relaxed max-w-lg">
            <T k="delivery.paragraph" fallback="Two delivery styles depending on where you're staying. Disney resorts + Airbnb/VRBO + Cabana Bay & Endless Summer: we meet you in person within your chosen window. Bonnet Creek, Disney Springs Area hotels, and most Universal properties: contactless drop-off at bell services — just ask at check-in. Free delivery on Walt Disney World & bookings over $75." />
          </p>
          <div className="mt-8 grid grid-cols-2 gap-6 max-w-md">
            <div className="glass p-5">
              <Clock className="w-5 h-5 text-[#FFD166]" />
              <div className="mt-3 font-serif text-2xl"><T k="delivery.stat1.value" fallback="24 hrs" /></div>
              <div className="text-xs text-[#B9C8D5]"><T k="delivery.stat1.label" fallback="Advance booking" /></div>
            </div>
            <div className="glass p-5">
              <Moon className="w-5 h-5 text-[#FFD166]" />
              <div className="mt-3 font-serif text-2xl"><T k="delivery.stat2.value" fallback="7 days" /></div>
              <div className="text-xs text-[#B9C8D5]"><T k="delivery.stat2.label" fallback="Week-long service" /></div>
            </div>
          </div>
        </Reveal>
        <div className="space-y-6">
          {resorts.map((group, idx) => (
            <Reveal key={group.area} delay={idx * 0.05}>
              <div className="glass p-6 hover:border-[#FFD166]/50 transition-colors" data-testid={`resort-group-${idx}`}>
                <div className="flex items-center gap-2 mb-3">
                  <MapPin className="w-4 h-4 text-[#FFD166]" />
                  <h3 className="font-serif text-xl">{group.area}</h3>
                </div>
                <div className="flex flex-wrap gap-2">
                  {group.resorts.map((r) => (
                    <span key={r} className="text-xs px-3 py-1.5 rounded-full bg-[#0d2438]/70 border border-[#4A94BF]/40 text-[#F6F1E4]/90">{r}</span>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
